import { render, staticRenderFns } from "./HistoryVoucher.vue?vue&type=template&id=641304eb&scoped=true"
import script from "./HistoryVoucher.vue?vue&type=script&lang=js"
export * from "./HistoryVoucher.vue?vue&type=script&lang=js"
import style0 from "./HistoryVoucher.vue?vue&type=style&index=0&id=641304eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641304eb",
  null
  
)

export default component.exports